import { useEffect } from "react";
import * as L from "leaflet";
import { Point } from "leaflet";
import { LeafletPixiContext, PixiState, UseStateType } from "@pages/monitoring/map/hooks/useLeafletPixi";
import logger from "@utils/logger";
import { useTypedSelector } from "@hooks/useTypedSelector";

const log = logger.getLogger("pixi.showOnMap")
export default function (pixiContext: LeafletPixiContext | undefined, [state, setPixiState]: UseStateType<PixiState>) {
    const { entities: GeoZoneData, ids: geoZoneIds } = useTypedSelector(data => data.geoZones)
    const { entities: UnitsData, ids: unitIds } = useTypedSelector(data => data.units)
    useEffect(() => {
        if (pixiContext) {
            const map = pixiContext.map
            if (state.showOnMap) {
                let unitPositions = state.selectedUnits.flatMap((fieldGlid: any) => {
                    if (UnitsData[fieldGlid]?.dynamic?.position) {
                        return [UnitsData[fieldGlid]!.dynamic!.position!]
                    } else {
                        log.warn("Dynamic position isn't ready yet (TODO!)")
                        return []
                    }
                })

                if (unitPositions.length) {
                    let bound = new L.Bounds(unitPositions as unknown as Point[])
                    let { x, y } = bound.getCenter()
                    y && x && map.setView([y, x], 15)
                }
            }
            setPixiState((state) => ({ ...state, showOnMap: false }))
        }
    }, [pixiContext, state.selectedUnits, unitIds])

    useEffect(() => {
        if (pixiContext) {
            const map = pixiContext.map
            if (state.showOnMap) {
                let geoZoneGeometries = state.selectedGeoZones.map((fieldGlid: any) => {
                    return GeoZoneData[fieldGlid]?.geometry?.coordinates[0]
                })

                if (geoZoneGeometries && geoZoneGeometries[0]?.length) {
                    // @ts-ignore
                    let bound = new L.Bounds(...geoZoneGeometries)
                    let { x = 0, y = 0 } = bound.getCenter()
                    y && x && map.setView([y, x], 15)
                }
            }
            setPixiState((state) => ({ ...state, showOnMap: false }))
        }
    }, [pixiContext, state.selectedGeoZones, geoZoneIds])
}